import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class GameSectionSkillService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  findAllBySection(idSection: string) {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}skills/section/${idSection}`).toPromise();
  }
}

